import axios from "./_axios";
import { API } from "./apiEndPoints";

export const getIntegrationsStatus = (account_id) => {
  return axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/${API.INTEGRATIONS_STATUS}`,
  });
};
